import { Component, OnInit } from '@angular/core';
import { Helper } from '../../Helper';
import { Router } from '@angular/router';
import { MatBottomSheet, MatDialog } from '@angular/material';
import { BottomSheetOverviewExampleSheet } from '../../tabs/tabs.component';

@Component({
  selector: 'app-trash',
  templateUrl: './trash.component.html',
  styleUrls: ['./trash.component.css','../../sub-admin/subadmin.component.css','../../../assets/bootstrap.css']
})
export class TrashComponent implements OnInit {

  displayedColumnsOffices: string[] =  ['user', 'subject',"description","action"];

  dataOffices=[

  ];
  showView=false;
  viewElement={};
  search=""
  timer=null
  data:any={}
  page=1
  per_page=25;
  constructor(public Helper:Helper , public router:Router,
    public dialog:MatDialog,
    private _bottomSheet: MatBottomSheet) { }

  ngOnInit() {
    this.getdata()
  }
  searchData(e){
      
    if(this.search=="")  return 1;  
    
    if(this.timer)
      clearTimeout(this.timer);

    this.timer=setTimeout(()=>{
       this.page=1;
       this.getdata()
    },500)
    
  }
  onBack(){
   
    this.showView=false;
  }
  searching=true;
  getdata(){
    this.searching=true;

    this.Helper.makeRequest("admin/trash?page="+this.page+"&search="+this.search,{},"get",{toast:false}).subscribe(d=>{
      console.log(d.data,"d.data")
      this.dataOffices= d.data.data;
      this.data= d.data;
      this.searching=false;
    })
  }
  prev(){
    this.page=this.page-1;
    this.getdata();
  }
  next(){
    this.page=this.page+1;
    this.getdata();
  }
  view(el){
      this.showView=true;
      this.viewElement=el.slug;
  }

  delete(el){
    let sheet=this._bottomSheet.open(BottomSheetOverviewExampleSheet,{ ariaLabel: 'Are you sure you want to delete this experience'});
    sheet.afterDismissed().subscribe((data) => {
      if(data){
        this.Helper.makeRequest("admin/delete-message/"+el.slug,{id:el.slug},"delete").subscribe(d=>{
          this.getdata();
             
        })
      }
       
    });
  }
   

}
